import React from 'react';

import './spinner.css';

const Spinner = () => {
	return (
		<div className="spinner">
			<div className="spinner__item">
				Loading...
			</div>
		</div>
	);
};

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/common/loaders/Spinner/index.js